/* eslint-disable */
import { createBrowserRouter, Navigate, useRouteError, isRouteErrorResponse } from "react-router-dom";
import { Helmet } from "react-helmet";
import App from "./App";
import React from 'react';
import MvLoader from "./MvLoader";
import NavBar from "./Navbar";
import Foot from "./footer";
// Heavy route-level components are code-split so the initial bundle stays
// small (important for the customizer/checkout on mobile networks).
const HomePage = React.lazy(() => import("./Homepage"));
const Login = React.lazy(() => import("./Auth"));
const Fabric = React.lazy(() => import("./Fabric"));
const SharedDesign = React.lazy(() => import("./Fabric/SharedDesign"));
const Checkout = React.lazy(() => import("./Checkout"));
const Profile = React.lazy(() => import("./Checkout/profile"));
const Presets_main = React.lazy(() => import("./Presets"));
const Preset_item = React.lazy(() => import("./Presets/Preset-item"));
const StudioCollection = React.lazy(() => import("./Presets/StudioCollection"));
const Feel_fabric = React.lazy(() => import("./Fabric/Feel"));
const Appointment = React.lazy(() => import("./Contact/appointment"));
const Measurement = React.lazy(() => import("./Measurements"));
const FootTrace = React.lazy(() => import("./Measurements/FootTrace"));
const Terms_C = React.lazy(() => import("./Contact/Terms_C"));
const Payments_page = React.lazy(() => import("./Checkout/Payment/index"));
const Order_page = React.lazy(() => import("./Presets/Order_page"));
const ReachUs = React.lazy(() => import("./Contact/reachus"));
const BlogPage = React.lazy(() => import("./Blog/BlogPage"));
const SuitBlazerBandhgalaPage = React.lazy(() => import("./Blog/SuitBlazerBandhgalaPage"));
const EmbroideryGuidePage = React.lazy(() => import("./Blog/EmbroideryGuidePage"));
const KurtaGuidePage = React.lazy(() => import("./Blog/KurtaGuidePage"));
const MadeToMeasurePage = React.lazy(() => import("./Blog/MadeToMeasurePage"));
const MeasureAtHomePage = React.lazy(() => import("./Blog/MeasureAtHomePage"));
const PlacementSuitPage = React.lazy(() => import("./Blog/PlacementSuitPage"));
const AboutUsPage = React.lazy(() => import("./About/AboutUsPage"));
const SizeChartPage = React.lazy(() => import("./Measurements/SizeChartPage"));
const WeddingPlannerPage = React.lazy(() => import("./Wedding/WeddingPlannerPage"));
const BusinessClothingPage = React.lazy(() => import("./Business/BusinessClothingPage"));
const CampusSuitStallsPage = React.lazy(() => import("./Campus/CampusSuitStallsPage"));
const SmartKioskFranchisePage = React.lazy(() => import("./Franchise/SmartKioskFranchisePage"));
const SendYourDesignPage = React.lazy(() => import("./DesignRequest/SendYourDesignPage"));

// Legal Pages
import TermsPage from "./Legal/TermsPage";
import PrivacyPage from "./Legal/PrivacyPage";
import ShippingPage from "./Legal/ShippingPage";
import CancellationPage from "./Legal/CancellationPage";
import ReturnsPage from "./Legal/ReturnsPage";

const chunkReloadKey = 'maviinci:chunk-reload-attempted';

function isChunkLoadError(error) {
  const message = String(error?.message || error || '');
  return /Loading chunk \d+ failed|ChunkLoadError|CSS_CHUNK_LOAD_FAILED/i.test(message);
}

/**
 * An address that matches no route lands here as a 404 from the router. It
 * used to get the chunk-reload screen below - "the app could not load the
 * latest page files, please refresh" - which is wrong, and every mistyped or
 * retired URL answered 200 with that page, a soft 404 to Google. This says what
 * happened, offers the way on, and is noindex.
 */
function NotFoundPage() {
  return (
    <main style={{ minHeight: '100vh', padding: '96px 20px', background: '#14110d', color: '#fffaf2' }}>
      <Helmet>
        <title>Page not found | MAVIINCI</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div style={{ maxWidth: 640, margin: '0 auto' }}>
        <p style={{ color: '#d8af68', letterSpacing: '.24em', fontSize: 12, fontWeight: 700, textTransform: 'uppercase' }}>404</p>
        <h1 style={{ fontSize: 36, margin: '10px 0 14px', fontWeight: 500 }}>This page doesn't exist</h1>
        <p style={{ lineHeight: 1.7, color: '#d8cab5' }}>
          The link may be old or mistyped. Everything we make is a click away from here.
        </p>
        <nav style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginTop: 26 }}>
          {[['/', 'Home'], ['/products', 'Shop the studio'], ['/custom/ethnic/select_cloth/personalize', 'Design your own'], ['/reachus', 'Contact us']].map(([to, label]) => (
            <a key={to} href={to} style={{ padding: '12px 18px', borderRadius: 6, border: '1px solid #3a3128', color: '#fffaf2', textDecoration: 'none', fontWeight: 600 }}>{label}</a>
          ))}
        </nav>
      </div>
    </main>
  );
}

function RouteErrorRecovery() {
  const error = useRouteError();
  const notFound = isRouteErrorResponse(error) && error.status === 404;

  React.useEffect(() => {
    if (notFound || !isChunkLoadError(error)) return;
    if (sessionStorage.getItem(chunkReloadKey)) return;

    sessionStorage.setItem(chunkReloadKey, '1');
    window.location.reload();
  }, [error, notFound]);

  if (notFound) return <NotFoundPage />;

  return (
    <main style={{ minHeight: '100vh', padding: '48px 20px', background: '#14110d', color: '#fffaf2' }}>
      <div style={{ maxWidth: 640, margin: '0 auto' }}>
        <h1 style={{ fontSize: 32, marginBottom: 12 }}>Something went wrong</h1>
        <p style={{ lineHeight: 1.6, color: '#d8cab5' }}>
          The app could not load the latest page files. Please refresh once.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{ marginTop: 20, padding: '12px 18px', border: 0, borderRadius: 6, background: '#d8af68', color: '#15110c', fontWeight: 700 }}
        >
          Refresh
        </button>
      </div>
    </main>
  );
}


const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <RouteErrorRecovery />,
    children: [
      {
        path: "/",
        element: (
          <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
              <NavBar flag={1} />
              <HomePage />
              <Foot />
            </>
          </React.Suspense>
        )
      },
      {
        path: "/profile/:tab?",
        element: (
          <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
              <NavBar flag={1} />
              <Profile />
              <Foot />
            </>
          </React.Suspense>
        )
      },
      {
        path:"/login",
        element:(
          <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
              <NavBar flag={1} />
              <Login/>
            </>
          </React.Suspense>
        )
      },
      {
        path:"/custom/jacket/:id?/:process?/:info?",
        element: <Navigate to="/custom/sadri/select_cloth/personalize" replace />
      },
      {
        path:"/custom/:category/:id/:process/:info?",
        element:
        <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
              {/* <NavBar flag={1} /> */}
              <Fabric/>
            </>
        </React.Suspense>
      },
      {
        path:"/s/:id",
        element:
        <React.Suspense fallback={<MvLoader variant="page" />}>
            <SharedDesign/>
        </React.Suspense>
      },
      {
        path:"/cart/:id?",
        element:
        <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
                <NavBar flag={1} />
                <Checkout/>
            </>
        </React.Suspense>
      },
      {
        path:"/products",
        element:
        <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
                <NavBar flag={5} />
                <StudioCollection/>
                <Foot />
            </>
        </React.Suspense>
      },
      {
        path:"/products/:cloth",
        element:
        <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
                <NavBar flag={5} />
                <Presets_main/>
                <Foot />
            </>
        </React.Suspense>
      },
      {
        // Occasion collections: /collections/groom-wear
        path:"/collections/:slug",
        element:
        <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
                <NavBar flag={5} />
                <Presets_main/>
                <Foot />
            </>
        </React.Suspense>
      },
      {
        // Style pages: /products/kurta/sherwani (department / style)
        path:"/products/:cloth/:style",
        element:
        <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
                <NavBar flag={5} />
                <Presets_main/>
                <Foot />
            </>
        </React.Suspense>
      },
      {
        path:"/products/:catr/:name/:id/:des?",
        element:
        <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
                <NavBar flag={5} />
                <Preset_item/>
                <Foot/>
            </>
        </React.Suspense>
      },
      {
        path:"/feel",
        element:
        <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
                <NavBar flag={1} />
                <Feel_fabric/>
                <Foot />
            </>
        </React.Suspense>
      },
      {
        path:"/reachus/:req?",
        element:
        <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
                <NavBar flag={1} />
                <ReachUs/>
                <Foot />
            </>
        </React.Suspense>
      },
      {
        // Mojari sizing: A4 foot tracing, straightened in the browser
        path:"/foot-trace",
        element:
        <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
                <NavBar flag={5} />
                <FootTrace/>
            </>
        </React.Suspense>
      },
      {
        path:"/measurement/:name/:info?",
        element:
        <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
                <NavBar flag={1} />
                <Measurement/>
            </>
        </React.Suspense>
      },
      {
        path:"/terms",
        element:
        <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
                <NavBar flag={1} />
                <TermsPage />
                <Foot />
            </>
        </React.Suspense>
      },
      {
        path:"/privacy",
        element:
        <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
                <NavBar flag={1} />
                <PrivacyPage />
                <Foot />
            </>
        </React.Suspense>
      },
      {
        path:"/shipping",
        element:
        <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
                <NavBar flag={1} />
                <ShippingPage />
                <Foot />
            </>
        </React.Suspense>
      },
      {
        path:"/cancellation",
        element:
        <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
                <NavBar flag={1} />
                <CancellationPage />
                <Foot />
            </>
        </React.Suspense>
      },
      {
        path:"/returns",
        element:
        <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
                <NavBar flag={1} />
                <ReturnsPage />
                <Foot />
            </>
        </React.Suspense>
      },
      {
        path:"/checkout/payment",
        element:
        <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
                <NavBar flag={1} />
                <Payments_page/>
                <Foot />
            </>
        </React.Suspense>
      },
      {
        path:"/order/:id",
        element:
        <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
                <NavBar flag={1} />
                <Order_page/>
                <Foot/>
            </>
        </React.Suspense>
      },

      {
        path:"/blog",
        element:
        <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
                <NavBar flag={1} />
                <BlogPage />
                <Foot />
            </>
        </React.Suspense>
      },
      {
        path:"/blog/suit-blazer-bandhgala",
        element:
        <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
                <NavBar flag={1} />
                <SuitBlazerBandhgalaPage />
                <Foot />
            </>
        </React.Suspense>
      },
      {
        path:"/blog/embroidery-guide",
        element:
        <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
                <NavBar flag={1} />
                <EmbroideryGuidePage />
                <Foot />
            </>
        </React.Suspense>
      },
      {
        path:"/blog/kurta-for-men-guide",
        element:
        <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
                <NavBar flag={1} />
                <KurtaGuidePage />
                <Foot />
            </>
        </React.Suspense>
      },
      {
        path:"/blog/made-to-measure-vs-readymade",
        element:
        <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
                <NavBar flag={1} />
                <MadeToMeasurePage />
                <Foot />
            </>
        </React.Suspense>
      },
      {
        path:"/blog/how-to-take-body-measurements",
        element:
        <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
                <NavBar flag={1} />
                <MeasureAtHomePage />
                <Foot />
            </>
        </React.Suspense>
      },
      {
        path:"/blog/placement-interview-suit",
        element:
        <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
                <NavBar flag={1} />
                <PlacementSuitPage />
                <Foot />
            </>
        </React.Suspense>
      },
      {
        path:"/size-chart",
        element:
        <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
                <NavBar flag={1} />
                <SizeChartPage />
                <Foot />
            </>
        </React.Suspense>
      },
      {
        path:"/about",
        element:
        <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
                <NavBar flag={1} />
                <AboutUsPage />
                <Foot />
            </>
        </React.Suspense>
      },
      {
        path: "/smart-kiosk-franchise",
        element: (
          <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
              <NavBar flag={1} />
              <SmartKioskFranchisePage />
              <Foot />
            </>
          </React.Suspense>
        )
      },
      {
        path: "/campus-suit-stalls",
        element: (
          <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
              <NavBar flag={1} />
              <CampusSuitStallsPage />
              <Foot />
            </>
          </React.Suspense>
        )
      },
      {
        path: "/send-your-design",
        element: (
          <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
              <NavBar flag={1} />
              <SendYourDesignPage />
              <Foot />
            </>
          </React.Suspense>
        )
      },
      {
        path: "/clothing-for-business",
        element: (
          <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
              <NavBar flag={1} />
              <BusinessClothingPage />
              <Foot />
            </>
          </React.Suspense>
        )
      },
      {
        path: "/wedding-outfit-planner",
        element: (
          <React.Suspense fallback={<MvLoader variant="page" />}>
            <>
              <NavBar flag={1} />
              <WeddingPlannerPage />
              <Foot />
            </>
          </React.Suspense>
        )
      }
      
    ]
  }
]);

export default router;
